import type { RadioTabProps } from '../const';

import { cn } from '@utils';

import { useContext } from 'react';
import { RadioTabDisplayName } from '../const';
import { RadioContext } from '../RadioTabs';
import './index.less';

function RadioTab(props: RadioTabProps) {
  const context = useContext(RadioContext);
  const { value, disabled, scrollable, isActive } = props;
  const { size } = context;
  const handleTabClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const { onTabClick } = context;
    if (onTabClick && !disabled) {
      onTabClick(value, e);
    }
  };

  return (
    <div
      className={cn('wg-radio-tab', `wg-radio-tab--size-${size}`, props.className, {
        'wg-radio-tab--active': isActive,
        [`wg-radio-tab--size-${size}-active`]: isActive,
        'wg-radio-tab--disabled': disabled,
      })}
      onClick={handleTabClick}
      style={props.style}
    >
      <div
        className={cn('wg-radio-tab__content', {
          'wg-radio-tab--disabled': disabled,
          'wg-radio-tab__content--scrollable': scrollable,
        })}
      >
        {props.children}
      </div>
    </div>
  );
}
RadioTab.displayName = RadioTabDisplayName;

export default RadioTab;
export type { RadioTabProps };
